import type { Generator } from "../../../../../../utils/backend-types";

export function areGeneratorsValid(
  generators: Array<Generator> | undefined,
  generatorsValue: Array<string> | undefined
) {
  const generatorIds = generators?.map((generator) => generator.id) ?? [];
  let hasInvalidValues = false;
  if (generatorsValue && generatorsValue.length > 0) {
    generatorsValue.forEach((generatorId) => {
      if (!generatorIds.includes(Number(generatorId))) {
        hasInvalidValues = true;
      }
    });
  }
  return hasInvalidValues;
}
